"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnRenderer = exports.getEditor = exports.getFormatter = void 0;
__exportStar(require("./types"), exports);
const checkbox_1 = require("./checkbox");
const date_1 = require("./date");
const link_1 = require("./link");
const lock_1 = require("./lock");
const number_1 = require("./number");
const select_1 = require("./select");
const select2_1 = require("./select2");
const template_1 = require("./template");
const text_1 = require("./text");
const textarea_1 = require("./textarea");
const time_1 = require("./time");
const TYPES = [
    checkbox_1.CHECKBOX,
    date_1.DATE,
    link_1.LINK,
    lock_1.LOCK,
    number_1.NUMBER,
    select_1.SELECT,
    select2_1.SELECT2,
    template_1.TEMPLATE,
    text_1.TEXT,
    textarea_1.TEXTAREA,
    time_1.TIME
];
function getFormatter(config) {
    for (let ct of TYPES) {
        if (ct.name == config.name) {
            return ct.formatter.createComponent(ct.formatter.schema.parse(config));
        }
    }
    return text_1.TEXT.formatter.createComponent(text_1.TEXT.formatter.schema.parse(config));
}
exports.getFormatter = getFormatter;
function getEditor(config) {
    for (let ct of TYPES) {
        if (ct.name == config.name) {
            return ct.editor.createComponent(ct.editor.schema.parse(config));
        }
    }
    return text_1.TEXT.editor.createComponent(text_1.TEXT.editor.schema.parse(config));
}
exports.getEditor = getEditor;
function getColumnRenderer(name) {
    for (let ct of TYPES) {
        if (ct.name == name) {
            return ct;
        }
    }
    return text_1.TEXT;
}
exports.getColumnRenderer = getColumnRenderer;
//# sourceMappingURL=index.js.map